{
  "articlesSection": "記事",
  "bookmarkTitleLabel": "ブックマーク",
  "communitiesSection": "コミュニティのディスカッション",
  "devConnectionLabel": "Developer Connection",
  "feedback": "フィードバック",
  "fetchFailed": "フェッチ失敗",
  "help": "ヘルプ",
  "helpLoadError": "問題が発生しています。再試行してください。",
  "noBookmarks": "ブックマークを使用すればここからコンテンツにアクセスできます",
  "noBookmarksTitle": "ブックマークなし",
  "noResults": "結果が見つかりません",
  "noResultsMessage": "つづりを確認するか、別の検索語句を試してください",
  "resourcesCustomerCareLabel": "サポートについて",
  "resourcesStatusLabel": "ステータス",
  "solutionsFilterLabel": "すべてのソリューション",
  "support": "サポート",
  "videosSection": "ビデオ"
}
